export default {
  baseURL: "http://localhost:8080/v1.0",
  timeout: 0,
  headers: {
    Accept: "*/*",
  },
};
